import NonAcademicContractDaysFields from './NonAcademicContractDaysFields.component';

export default NonAcademicContractDaysFields;
